/* eslint-disable no-useless-catch */
import { useMutation, useQueryClient } from "react-query";
import axios from "axios";
import { toast } from "ToastAlertContainer";

const updateUserEmail = async ({ userId, userEmailId, userEmail }) => {
  let pathAndHost = window.location.protocol + window.location.host;

  let url = new URL(`/api/v2/users/${userId}/emails/${userEmailId}`, pathAndHost);

  let updatedUserEmail;
  try {
    updatedUserEmail = await axios.patch(url.toString(), userEmail);
  } catch (err) {
    console.error(err.response.data);
    throw err;
  }

  return updatedUserEmail.data;
};

export default function useUpdateUserEmail() {
  const queryClient = useQueryClient();

  return useMutation(
    async ({ userId, userEmailId, userEmail }) => {
      try {
        await updateUserEmail({
          userId,
          userEmailId,
          userEmail,
        });
      } catch (err) {
        throw err;
      }
    },
    {
      onMutate: async ({ userId, userEmailId, userEmail }) => {
        await queryClient.cancelQueries(["users", userId, "emails"]);

        let previousUserEmails = queryClient.getQueryData(["users", userId, "emails"]);

        var previousUserEmailsClone = JSON.parse(JSON.stringify(previousUserEmails));

        let optimisticUserEmails = previousUserEmails.map(previousUserEmail => {
          if (userEmailId === previousUserEmail.user_email_id) {
            // console.log("previousUserEmail in map :>> ", previousUserEmail);
            previousUserEmail.is_primary = true;
          } else {
            previousUserEmail.is_primary = false;
          }
          return previousUserEmail;
        });

        queryClient.setQueryData(["users", userId, "emails"], optimisticUserEmails);

        previousUserEmails = previousUserEmailsClone;
        return {
          previousUserEmails,
          optimisticUserEmails,
          userId,
        };
      },
      onError: (err, userEmail, context) => {
        queryClient.setQueryData(["users", context.userId, "emails"], context.previousUserEmails);
      },
      onSettled: (data, err) => {
        if (err) {
          return;
        }
        if (data && data.user_id) {
          queryClient.invalidateQueries(["users", data.user_id, "emails"]);
        }
      },
    }
  );
}
